<template>
  <div class="article-recommend" v-loading="loading">
    <div v-if="rowCount > 0">
      <MaterialArticleCard
        ref="materialarticle"
        v-for="item in list"
        :key="item.favoriteResourceId"
        :item="item"
        @getList="getList"
      ></MaterialArticleCard>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :total="rowCount"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          @current-change="getList"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
    <div class="nodata-tip" v-if="rowCount <= 0 && !loading">
      <img src="../../assets/image/material/empty.png" alt="" />
      <p>空空如也，您还没有收藏文章</p>
    </div>
  </div>
</template>

<script>
import MaterialArticleCard from "../../components/share/Material/MaterialArticleCard";

import { mapActions, mapState, mapMutations } from "vuex";
export default {
  components: { MaterialArticleCard },

  data() {
    return {
      loading: false,
      pageIndex: 1,
      pageSize: 24
    };
  },
  computed: {
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    },
    ...mapState("material", {
      rowCount: state => state.article.rowCount,
      list: state => state.article.list,
      labelId: state => state.labelId,
      pageHeight: "pageHeight"
    })
  },
  watch: {
    contentHeight: {
      handler(val) {
        this.getHotLineHeight(
          val,
          "article-recommend",
          this.pageHeight,
          "class"
        );
      }
    }
  },
  methods: {
    ...mapActions("material", ["AFavoriteResources"]),
    ...mapMutations("material", ["AsetArticleData"]),
    async getList(pageIndex) {
      this.loading = true;
      var result = await this.AFavoriteResources({
        pageIndex,
        pageSize: this.pageSize,
        labelId: this.labelId
      });
      this.loading = false;
      if (result.errorCode === 0) {
        this.AsetArticleData(result.data);
        // this.list = result.data.dataSource;
        // this.rowCount = result.data.rowCount;
      } else {
        this.$message({
          showClose: true,
          message: result.errorMess,
          type: "error"
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getHotLineHeight(
        this.contentHeight,
        "article-recommend",
        this.pageHeight,
        "class"
      );
    });
    this.getList(1);
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";
.article-recommend {
  height: 300px;
  width: 100%;
  overflow: auto;
  overscroll-behavior-y: contain;
}

.material-card {
  padding: 15px 0;
  padding-right: 5px;
}
.page {
  margin: 10px;
}
</style>
